module.exports = __webpack_public_path__ + "static/media/ibm.79e598de.svg";